import React from 'react'
import './index.scss'
import IdealWind from './ideal-wind'

class ExtendedDataDisplay extends React.Component {
  constructor(props) {
    super(props)
  }

  getExtension() {
    const { marker } = this.props
    return (< IdealWind marker={marker} onClose={this.props.onClose} />)
  }

  render() {
    const extension = this.getExtension()
    return (
      <div className='extended-data-content' style={{ top: this.props.dropdownHeight, }}>
        {extension}
      </div>
    )
  }
}

export default ExtendedDataDisplay